import React, { useState } from "react";
import { changePassword } from "../api/UserAPI";
import { getUserMessage, logApiError } from "../api/apiError";

interface Props {
    token: string;
}

const ChangePasswordPanel: React.FC<Props> = ({ token }) => {
    const [current, setCurrent]       = useState("");
    const [newPw, setNewPw]           = useState("");
    const [confirm, setConfirm]       = useState("");
    const [showPassword, setShow]     = useState(false);
    const [loading, setLoading]       = useState(false);
    const [error, setError]           = useState<string | null>(null);
    const [success, setSuccess]       = useState<string | null>(null);

    const handleSubmit = async (e: React.FormEvent) => {
        e.preventDefault();
        setError(null);
        setSuccess(null);

        if (newPw !== confirm) {
            setError("New passwords do not match.");
            return;
        }

        setLoading(true);
        try {
            await changePassword(token, current, newPw);
            setSuccess("Password changed successfully.");
            setCurrent("");
            setNewPw("");
            setConfirm("");
        } catch (err) {
            logApiError(err);
            setError(getUserMessage(err));
        } finally {
            setLoading(false);
        }
    };

    const inputType = showPassword ? "text" : "password";

    return (
        <div className="space-y-4">
            <h2 style={{ marginBottom: "1.5rem" }}>Change Password</h2>
            <div className="section-box">
                <form onSubmit={handleSubmit}>
                    <div style={{ display: "flex", flexDirection: "column", gap: "1rem", maxWidth: 420 }}>
                        <div className="form-group" style={{ marginBottom: 0 }}>
                            <label>Current Password</label>
                            <input
                                type={inputType}
                                value={current}
                                onChange={(e) => setCurrent(e.target.value)}
                                placeholder="Enter current password"
                                disabled={loading}
                                required
                            />
                        </div>
                        <div className="form-group" style={{ marginBottom: 0 }}>
                            <label>New Password</label>
                            <input
                                type={inputType}
                                value={newPw}
                                onChange={(e) => setNewPw(e.target.value)}
                                placeholder="At least 8 characters"
                                disabled={loading}
                                required
                            />
                        </div>
                        <div className="form-group" style={{ marginBottom: 0 }}>
                            <label>Confirm New Password</label>
                            <input
                                type={inputType}
                                value={confirm}
                                onChange={(e) => setConfirm(e.target.value)}
                                placeholder="Re-enter new password"
                                disabled={loading}
                                required
                            />
                        </div>
                        <div>
                            <label style={{ display: "inline-flex", alignItems: "center", gap: "0.4rem", cursor: "pointer", userSelect: "none" }}>
                                <input
                                    type="checkbox"
                                    checked={showPassword}
                                    onChange={(e) => setShow(e.target.checked)}
                                    style={{ width: "auto" }}
                                />
                                Show passwords
                            </label>
                        </div>
                        <div>
                            <button type="submit" disabled={loading}>
                                {loading ? "Saving…" : "Change Password"}
                            </button>
                        </div>
                        {error   && <div className="error-message">{error}</div>}
                        {success && <div style={{ color: "var(--color-success, green)" }}>{success}</div>}
                    </div>
                </form>
            </div>
        </div>
    );
};

export default ChangePasswordPanel;
